import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
// import { convertDateToUTC } from '../../../../utils/dateUtil'
// import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';

export default Vue.component('specialty-types-card', {
  name: 'SpecialtyTypesCard',
  data () {
    let color: any
    return {
      msg: 'SpecialtyTypesCard',
      cardExpanded: false,
      color: color,
      loadingSpecialtyTypeData: false,
      specialtyTypesErrorMessage: '',
      specialtyTypeData: [ { id: 1, specialty: '', oldSpecialty: '',
        specialtyShortName: '', oldSpecialtyShortName: '',
        isTelemedicine: false, oldIsTelemedicine: false,
        isEditing: true, isSaving: false} ]
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  filters: {

  },
  created: function () {
    this.specialtyTypeData = [];
  },
  methods: {
    isSpecialtyTypeEditable(id: number) {
      return id !== 18 && id !== 23;
    },
    expandCard () {
      // alert(this.cardExpanded);
      this.cardExpanded = !this.cardExpanded;
      // alert(this.cardExpanded);
      if (this.cardExpanded) {
        this.getSpecialtyTypes()
      }
    },
    getSpecialtyTypes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingSpecialtyTypeData = true;
      }, 500);
      self.specialtyTypesErrorMessage = ''
      HTTP.get('/api/specialtyTypes/')
      .then(function (response) {
        let specialtyTypes = response.data.data;
        specialtyTypes.map(function (specialtyType: any) { specialtyType.isEditing = false; specialtyType.isSaving = false; });
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingSpecialtyTypeData = false;
        self.specialtyTypeData = specialtyTypes;
      })
      .catch(function (error) {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingSpecialtyTypeData = false;
        self.specialtyTypesErrorMessage = error;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred getting the Specialty Types.',
          duration: 5000
        });
      })
    },
    addSpecialtyType () {
      this.specialtyTypeData.push(
        { id: +('-' + new Date().getTime()),
          specialty: '', oldSpecialty: '',
          specialtyShortName: '', oldSpecialtyShortName: '',
          isTelemedicine: false, oldIsTelemedicine: false,
          isEditing: true, isSaving: false}
      );
    },
    editSpecialtyType (specialtyType: any) {
      specialtyType.oldSpecialty = specialtyType.specialty;
      specialtyType.oldSpecialtyShortName = specialtyType.specialtyShortName;
      specialtyType.oldIsTelemedicine = specialtyType.isTelemedicine;
      specialtyType.isEditing = !specialtyType.isEditing;
    },
    cancelEditSpecialtyType (specialtyType: any) {
      if (specialtyType.id < 0) {
        let index = this.specialtyTypeData.indexOf(specialtyType);
        this.specialtyTypeData.splice(index, 1);
      }
      specialtyType.specialty = specialtyType.oldSpecialty;
      specialtyType.specialtyShortName = specialtyType.oldSpecialtyShortName;
      specialtyType.isTelemedicine = specialtyType.oldIsTelemedicine;
      specialtyType.isEditing = !specialtyType.isEditing;
    },
    saveEditSpecialtyType (specialtyType: any) {
      let self = this;
      // If the Specialty Type's ID is negative, it has not yet been saved to the DB. Request a "Create".
      specialtyType.isSaving = true;
      if (specialtyType.id < 0) {
        HTTP.post('/api/specialtyTypes/',{
          'specialty': specialtyType.specialty,
          'specialtyShortName': specialtyType.specialtyShortName,
          'isTelemedicine': specialtyType.isTelemedicine
        })
        .then(function (response) {
          self.getSpecialtyTypes();
          // ToDo announce the returned message via temporary popup.
          specialtyType.oldSpecialty = specialtyType.specialty;
          specialtyType.oldSpecialtyShortName = specialtyType.specialtyShortName;
          specialtyType.oldIsTelemedicine = specialtyType.isTelemedicine;
          specialtyType.isEditing = !specialtyType.isEditing;
          specialtyType.isSaving = false;
        })
        .catch(function (error) {
          console.log('response Error!');
          self.specialtyTypesErrorMessage = error;
          specialtyType.isSaving = false;

          let errorMessages = [];
          let noErrorsFound = true;
          errorMessages.push( getRestParamErrorMessage(error, 'specialty') );
          errorMessages.push( getRestParamErrorMessage(error, 'specialtyShortName') );
          errorMessages.push( getRestParamErrorMessage(error, 'isTelemedicine') );
          errorMessages.forEach(function (errorMessage) {
            if (!errorMessage.length) { return; }
            noErrorsFound = false;
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: errorMessage,
              duration: 5000
            });
          });
          if (noErrorsFound) {
            let generalError = getRestResponseErrorMessage(error);
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: generalError ? generalError : 'An error occurred adding the Specialty Type.',
              duration: 5000
            });
          }
        })
      } else {
        // Else request an update to an existing Holiday in the DB.
        HTTP.put('/api/specialtyTypes/',{
          'id': specialtyType.id,
          'specialty': specialtyType.specialty,
          'specialtyShortName': specialtyType.specialtyShortName,
          'isTelemedicine': specialtyType.isTelemedicine
        })
        .then(function (response) {
          self.getSpecialtyTypes();
          // ToDo announce the returned message via temporary popup.
          specialtyType.oldSpecialty = specialtyType.specialty;
          specialtyType.oldSpecialtyShortName = specialtyType.specialtyShortName;
          specialtyType.oldIsTelemedicine = specialtyType.isTelemedicine;
          specialtyType.isEditing = !specialtyType.isEditing;
          specialtyType.isSaving = false;
        })
        .catch(function (error) {
          console.log('response Error!');
          self.specialtyTypesErrorMessage = error;
          specialtyType.isSaving = false;

          let errorMessages = [];
          let noErrorsFound = true;
          errorMessages.push( getRestParamErrorMessage(error, 'specialty') );
          errorMessages.push( getRestParamErrorMessage(error, 'specialtyShortName') );
          errorMessages.push( getRestParamErrorMessage(error, 'isTelemedicine') );
          errorMessages.forEach(function (errorMessage) {
            if (!errorMessage.length) { return; }
            noErrorsFound = false;
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: errorMessage,
              duration: 5000
            });
          });
          if (noErrorsFound) {
            let generalError = getRestResponseErrorMessage(error);
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error',
              text: generalError ? generalError : 'An error occurred editing the Specialty Type.',
              duration: 5000
            });
          }
        })
      }

    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/specialtyTypes/SpecialtyTypesCard.ts